import * as Styled from './CustomEmbeddedCode.styled';
import { StyledContentContainer } from '../../containers/StyledContentContainer.styled';

/**
 * At the moment, CustomEmbeddedCode does not need CustomEmbeddedCodeBlockDataProps.
 * Omitted because, in Typescript, empty interfaces accept any non-nullable value.
 */
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `CustomEmbeddedCode` content block allows users to embed a sandboxed iframe.
 *
 * A sandboxed iframe provides a secure environment for pseudo-trusted content. Currently, only
 * `allow-scripts` is allowed, and cannot be overridden.
 *
 * **❌ Blocked by Sandbox:**
 * - **Popups**: \`window.open()\` calls are blocked
 * - **Same-origin access**: Cannot access parent page cookies/storage
 * - **Form submission**: Forms cannot be submitted
 * - **Plugin loading**: No Flash, Java, etc.
 * - **Top navigation**: Cannot navigate parent page
 * - **Modal dialogs**: \`alert()\`, \`confirm()\` may be restricted
 *
 * **✅ Still Allowed:**
 * - **JavaScript execution**: Scripts can run within the iframe
 * - **DOM manipulation**: Within the iframe only
 * - **Event handling**: User interactions work normally
 * - **Styling**: CSS works normally
 *
 * <!-- hide from storybook
 * TODO: research `referrerPolicy` attribute
 * -->
 */
export const CustomEmbeddedCode = ({
  title = '',
  style = {},
  iframeWidth = '150px',
  // same as browser default
  iframeHeight = '150px',
  fit = false,
  src = '',
  parentLayoutInfo,
  dataIframeId
}) => /*#__PURE__*/_jsx(StyledContentContainer, {
  parentLayoutInfo: parentLayoutInfo,
  fit: !!fit,
  children: /*#__PURE__*/_jsx(Styled.Iframe, {
    src: src,
    "data-id": "cp-custom-embedded-code",
    "data-iframe-id": dataIframeId,
    title: title,
    fit: fit,
    style: style
    /**
     * Use CSS to set the iframe's width and height.
     * Note, using props named "width" and "height" would have populated the same attributes on
     * the iframe element, which we don't want. For example, "100%" is not a valid width value.
     */,
    iframeWidth: iframeWidth,
    iframeHeight: iframeHeight
    /**
     * ! Do not add "allow-same-origin". It is a security risk.
     */,
    sandbox: "allow-scripts"
  })
});